import React from 'react'

export const ResponsiveGuides = ({ development }) => {
  return development ? (
    <div className="text-white bg-black text-center uppercase fixed bottom-0 left-0 right-0 z-50">
      <div className="hidden 2xl:block">2xl</div>
      <div className="hidden xl:block  2xl:hidden">xl</div>
      <div className="hidden lg:block  xl:hidden">lg</div>
      <div className="hidden md:block  lg:hidden">md</div>
      <div className="hidden sm:block  md:hidden">sm</div>
      <div className="block  sm:hidden">xs</div>
    </div>
  ) : (
    <></>
  )
}
